<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { renderMarkdown } from '@/utils/markdown';

const props = defineProps<{ content: string }>();
const router = useRouter();
const html = computed(() => renderMarkdown(props.content));

/** Interne links (bv. /products/12) via de router openen i.p.v. een volledige paginalading. */
function onClick(e: MouseEvent) {
  const a = (e.target as HTMLElement | null)?.closest?.('a[data-internal]') as HTMLAnchorElement | null;
  if (!a) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
  e.preventDefault();
  router.push(a.getAttribute('href') ?? '/');
}
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -- eigen renderer: alle tekst wordt ge-escaped, alleen bekende tags -->
  <div class="kl-md" @click="onClick" v-html="html"></div>
</template>
